export default __webpack_public_path__ + "d314a288f53a723a546491830c2d423d.svg";